export default {
    filtros: {
        ordem: 'Order',
        resultado: 'Result',
        origem: 'Origin',
        destino: 'Destiny',
        titulo: 'Filters',
        mostrar_filtros: 'Show Filters',
        esconder_filtros: 'Hide Filters',
        nome: 'Name',
        codigo: 'Code',
        componente: 'Component',
        material: 'Material',
        complement: 'Complement',
        metodo: 'Method',
        metodos: 'Methods',
        tempos: 'Times',
        escala: 'Scale',
        integracao: 'Integration',
        detalhes: 'Details',
        botao_filtrar: 'Filter',
        integracoes: 'Integrations',
        logs: 'Logs',
    },
    ordem: {
        titulo_pagina: 'Mapping Order',
        exams: {
            empty: 'No exam found for the specified filters!',
            origem: 'Exams Origin',
            destino: 'Destination Exams',
            botao_salvar: 'Save',
            sucesso: 'Mapping, successfully saved!'
        }
    },
    resultado: {
        titulo_pagina: 'Mapping Result',
        exams: {
            empty: 'No exam found for the specified filters!',
            origem: 'Exams Origin',
            destino: 'Destination Exams',
            parse_personalizado: 'Custom Parse',
            botao_salvar: 'Save',
            sucesso: 'Mapping, successfully saved!'
        }
    },
    metodo: {
        titulo_pagina: 'Mapping Methods',
        empty: 'No method found!',
        origem: 'Source Methods',
        destino: 'Destination Methods',
        botao_salvar: 'Save',
        sucesso: 'Mapping, successfully saved!'
    },
    material: {
        titulo_pagina: 'Mapping Materials',
        empty: 'No material found!',
        origem: 'Source Materials',
        destino: 'Target Materials',
        botao_salvar: 'Save',
        sucesso: 'Mapping, successfully saved!'
    },
    complement: {
        titulo_pagina: 'Mapping Complements',
        empty: 'No complement found!',
        origem: 'Origin Complements',
        destino: 'Destination Complement',
        botao_salvar: 'Save',
        sucesso: 'Mapping, successfully saved!'
    },
    tipo: {
        titulo_pagina: 'Mapping Type',
        empty: 'No Item Found!',
        origem: 'Source Items',
        destino: 'Target Items',
        botao_salvar: 'Save',
        sucesso: 'Mapping, successfully saved!',
        selecione_tipo: 'Select Type!',
        depara_sucesso: 'Mappings successfully registered!',
        depara_erro: 'Error when Registering mappings!'
    },
    exame_resultado: {
        titulo_pagina: 'Mapping Result Value',
        empty: 'No exam results found!',
        exame: 'Exam',
        origem: 'Origin',
        destino: 'Destiny',
        selecione_exame: 'Select Exam!',
        depara_sucesso: 'Mappings successfully registered!'
    },
    copia: {
        copiar_dexpara: 'Copy Mapping',
        tipo_integracao: 'Integration Type',
        para_integracao: 'For Integration',
        origem: 'Origin',
        destino: 'Destiny',
        sucesso: 'The integration was copied successfully!',
        sim: 'Yes',
        nao: 'No',
        erro: {
            vazio: 'The integration type and integration fields must be filled in!',
            integracao_origem: 'The origin integration must be selected to copy it!',
            integracao_destino: 'The destination integration must be selected to copy it!',
            copiar: 'An error occurred when trying to copy the integration!',
            tipo: 'The type field must be selected to save the integration copy!'
        },
        confirmacao: {
            titulo: 'Integration Copy',
            mensagem: 'Are you sure you want to copy this integration?'
        }
    },
    log: {
        origem: 'Origin',
        destino: 'Destination',
        vazio: 'No log registered.',
        ultimo: {
            info: 'Last edited by',
            complemento: 'on'
        }
    }
}
